import {Completable, LoanSummaryDTO, pending} from 'kashable-mobile-common';

import {getApplication} from '../apis/application';
import {RootState} from '../store';

import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

const INITIAL_STATE: Completable<LoanSummaryDTO> = pending();

export const fetchAppSummary = createAsyncThunk(
    'appSummary/fetch',
    async (application, {rejectWithValue}) => {
        const response = await getApplication();
        if (response.error) {
            rejectWithValue(response);
        }

        return response;
    },
);

export const appSummarySlice = createSlice({
    name: 'appSummary',
    initialState: INITIAL_STATE,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        clearApplicationSummary: () => {
            return {...INITIAL_STATE};
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAppSummary.pending, () => {
                return pending();
            })
            .addCase(fetchAppSummary.fulfilled, (state, action) => {
                return {...action.payload};
            });
    },
});

export const {
    clearApplicationSummary,
} = appSummarySlice.actions;

export const selectAppSummary = (state: RootState) => state.appSummary;
export default appSummarySlice.reducer;
